import "./polyfill";
import React from "react";
import "./index.css";
import "./design-system/tokens/fonts.css";
import "./design-system/tokens/colors.css";
import "./design-system/tokens/typography.css";
import "./design-system/tokens/spacing.css";
import App from "./App";

// Disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from "./registerServiceWorker";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./_services/store/store";
import { registerChunkErrorReload } from "./_services/chunkReload";

unregister();
registerChunkErrorReload();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

/*
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);
 */
